import {Modal, Button} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {IKanbanStage} from '../../../types/kanban'

interface Props {
  show: boolean
  stage?: IKanbanStage | null
  loading?: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ModalDeleteKanbanStage: React.FC<Props> = ({show, stage, loading, onClose, onConfirm}) => {
  const intl = useIntl()
  return (
    <Modal show={show} onHide={onClose} centered className='kanban-stage-delete-modal'>
      <Modal.Header closeButton>
        <Modal.Title><FormattedMessage id='leads.kanban.deleteColumn' defaultMessage='Delete column' /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {intl.formatMessage({id: 'leads.kanban.deleteColumnConfirm', defaultMessage: 'Are you sure you want to delete the column <b>{name}</b>? This action cannot be undone.'}, {name: stage?.name, b: (chunks: (string | JSX.Element)[]) => <strong>{chunks}</strong>})}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onClose} disabled={loading}>
          <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
        </Button>
        <Button variant='danger' onClick={onConfirm} disabled={loading}>
          {loading ? intl.formatMessage({id: 'leads.kanban.deleting', defaultMessage: 'Deleting...'}) : intl.formatMessage({id: 'common.action.delete', defaultMessage: 'Delete'})}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
